export abstract class NpPathResolver {
    abstract LOGIN_PATH: string;
    abstract FORBIDDEN_PATH: string;
}
